<template>
  <div class="agreen-modal">
    <a-modal v-model="visible" :title="title" :footer="null" :width="800">
      <div>{{ content }}</div>
    </a-modal>
  </div>
</template>

<script>
export default {
  name: 'AgreenModal',
  props: {
    content: {
      type: String,
      default: '用参赛协议',
    },
    title: {
      type: String,
      default: '道吧网办赛协议',
    },
  },
  data() {
    return {
      visible: false,
    }
  },
  components: {},
  mounted() {},
  methods: {},
  watch: {},
}
</script>

<style scoped lang="scss"></style>



// WEBPACK FOOTER //
// src/daoba-match/views/matchcenter/components/AgreenModal.vue